import { PARTIAL_DRAFT_LEFT_OUT_FIELDS } from "../constants/stepConfig"

const isLeftOut = (key, value) =>
  key === PARTIAL_DRAFT_LEFT_OUT_FIELDS.wizardStep || (key === PARTIAL_DRAFT_LEFT_OUT_FIELDS.emptySubcategories && value === "")

/**
 * The payload a step saves. For a half-filled draft save (isPartial) it is the step's payload without
 * the fields the server would refuse it for (see PARTIAL_DRAFT_LEFT_OUT_FIELDS); the listing's last
 * saved step then stays the last finished one, which is where Continue Creating reopens it.
 */
export const getSavePayload = (payload, { isPartial = false } = {}) => {
  if (!isPartial || !(payload instanceof FormData)) return payload
  const partial = new FormData()
  for (const [key, value] of payload.entries()) {
    if (!isLeftOut(key, value)) partial.append(key, value)
  }
  return partial
}
